import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const DisplayOptimizedContext = /*#__PURE__*/createContext({
  isDisplayOptimized: false
});
export const DisplayOptimizedProvider = ({
  children,
  value
}) => {
  return /*#__PURE__*/_jsx(DisplayOptimizedContext.Provider, {
    value: {
      isDisplayOptimized: value
    },
    children: children
  });
};
export const useIsDisplayOptimized = () => {
  const {
    isDisplayOptimized
  } = useContext(DisplayOptimizedContext);
  return isDisplayOptimized;
};